import { useMutation } from "@apollo/client";
import { evictFields } from "../../../helpers/cache";
import { DeepPartial, useForm } from "react-hook-form";
import { toast } from "react-toastify";

import { CREATE_CUSTOMER_TASK } from "../customer-task.queries";
import { parseParams } from "../../../helpers/clean-object";

import { CreateCustomerTaskInput } from "../../../__generated__/globalTypes";
import {
  CreateCustomerTaskMutation,
  CreateCustomerTaskMutationVariables,
} from "../../../__generated__/CreateCustomerTaskMutation";

interface IProps {
  defaultValues: DeepPartial<CreateCustomerTaskInput>;
  onCompleted: (id?: number | null) => any;
}

export const useCreateCustomerTask = ({ defaultValues, onCompleted }: IProps) => {
  const form = useForm<CreateCustomerTaskInput>({
    mode: "all",
    defaultValues,
  });
  const [mutate, { loading }] = useMutation<
    CreateCustomerTaskMutation,
    CreateCustomerTaskMutationVariables
  >(CREATE_CUSTOMER_TASK, {
    refetchQueries: ["CustomerTasksQuery"],
    update(cache) {
      evictFields(cache, ["customerTask", "customerTasks", "customer"]);
    },
  });

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          input: parseParams(input),
        },
      });

      if (data?.createCustomerTask?.ok) {
        onCompleted(data.createCustomerTask.id);
      } else {
        throw Error(data?.createCustomerTask?.error ?? "Error");
      }
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
    }
  };
  return {
    form,
    mutate,
    loading,
    submit,
  };
};
